module.exports = "<template>\r\n    You are logged out click <a route-href=\"{route: login}\">here</a> to login.\r\n</template>";